import { useMemo, useState } from 'react'

import { NumberInput } from 'core-components/library/inputs'

import { IValidateNumberProps } from './models/IValidateNumberProps'
import { ValidationStatus } from './models/IValidationStatus'
import { Validator } from './Validator'

export const ValidateNumber = (props: IValidateNumberProps) => {
  const [validateStatus, setValidateStatus] = useState<ValidationStatus>(ValidationStatus.Valid)
  const valueDependencies = useMemo(() => {
    if (props.valueDependencies) {
      return props.valueDependencies
    }
    return [props.disabled]
  }, [props.disabled, props.valueDependencies])

  return (
    <Validator
      classes={props.classes?.validatorClasses}
      value={props.value}
      throttle={props.throttle}
      checkFn={props.disabled ? null : props.checkFn}
      valueDependencies={valueDependencies}
      tooltipVisible={props.tooltipVisible}
      onChangeValidation={(status) => setValidateStatus(status)}
    >
      <NumberInput
        {...props}
        classes={props.classes?.inputClasses}
        wrapper={validateStatus === ValidationStatus.Invalid ? 'danger' : 'normal'}
      />
    </Validator>
  )
}
